import styled from 'styled-components';
import { useSimulationContext } from '../../contexts/SimulationContext';
import DataService from '../../services/DataService';
import { SIMULATION_COUNTRY_STATES } from '../../data';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1px;
  padding: 8px 16px;
  background-color: #333;
  color: #fff;
`;

export const Summary = () => {
  const { simulation, simulationCountry } = useSimulationContext();

  if (!simulation || !simulationCountry) {
    return;
  }

  const countryList = DataService.getItem('countryList');
  const country = countryList.find(c => c.countryId === simulationCountry.countryId);

  const getSCYearStatus = () => {
    const { simulationCountryState, simulationCountryYear } = simulationCountry;

    if (simulationCountryState === SIMULATION_COUNTRY_STATES.NEW) {
      return 'Year 0';
    }

    if (
      [SIMULATION_COUNTRY_STATES.END_YEAR, SIMULATION_COUNTRY_STATES.END_SIMULATION].includes(simulationCountryState)
    ) {
      return `Year ${simulationCountryYear} — ready to start Year ${simulationCountryYear + 1}`;
    }

    return `Year ${simulationCountryYear}`;
  };

  return (
    <Wrapper>
      <div>
        <img src={`/images/flags/${country.countryCode}.png`} alt="" />
        <span style={{ paddingLeft: 8 }}>{country.countryName}</span>
      </div>
      <div>{getSCYearStatus()}</div>
      <div>Population: {simulationCountry.population}</div>
      <div>Gold: {simulationCountry.gold.toFixed(0)}</div>
      <div>Pollution: {simulationCountry.pollution}</div>
    </Wrapper>
  );
};
